<template>
  <div
    ref="container"
    @mousedown="handleMouseDown"
    @mousemove="handleMouseMove"
    @mouseup="handleMouseUp"
    @mouseleave="handleMouseLeave"
    class="gantt-slider"
  ></div>
</template>  
  
<script>
import { ref, onMounted } from "vue";
import { isDragging } from "@/views/rdmanagement/components/customGantt/components/serve";

export default {
  setup() {
    const container = ref();
    let initialX = 0;
    let initialY = 0;
    const startX = 0;
    const startY = 0;
    let position = { x: 0, y: 0 };

    onMounted(() => {
      container.value.addEventListener("mousedown", handleMouseDown);
    });

    function handleMouseDown(event) {
      event.preventDefault();
      initialX = event.clientX - startX;
      initialY = event.clientY - startY;
      isDragging.value = true;
    }

    function handleMouseMove(event) {
      if (isDragging.value) {
        event.preventDefault(); // 阻止默认行为，例如拖动选择文本等。
        const dx = event.clientX - initialX;
        const dy = event.clientY - initialY;
        position.x += dx;
        position.y += dy;
        // 在这里可以根据position.x和position.y的值来更新元素的位置，例如通过css来动态改变元素的位置。
        // console.log(position.x, position.y, container.value);

        // container.value.style.transform = `translateX(${position.x}px)`;
      }
    }

    function handleMouseLeave(event) {
      // isDragging.value = false;
    }

    function handleMouseUp() {
      isDragging.value = false;
    }

    return {
      container,
      handleMouseDown,
      handleMouseLeave,
      handleMouseMove,
      handleMouseUp,
      position,
    };
  },
};
</script>

<style lang="less" scoped>
.gantt-slider {
  max-height: calc(100vh - 121px);
  width: 10px;
  background: rgb(255, 243, 243);
  transition: all 0.1s linear;
  cursor: w-resize;
}
.slider-move-area {
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
}
</style>
